// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3306":"51e36e84","3815":"0eee446c","4990":"7873deca","7086":"3538c4fb","7998":"0eee446c"}[chunkId] + ".chunk.css";
};